import { Component, Input } from '@angular/core';
import { HybrisLayerViewDetails } from 'private/app/models/user.model';

@Component({
    selector: 'hvac-layer-view-hybris-data',
    templateUrl: './layer-view-hybris-data.component.html',
    styleUrls: ['./layer-view-hybris-data.component.scss']
})
export class LayerViewHybrisDataComponent {
    @Input() hybrisData: HybrisLayerViewDetails[];
}
